import TableContainer from "@material-ui/core/TableContainer"
import { Paper } from "@material-ui/core"
import React from "react"

export const PaperTableMd = ({children}) => <TableContainer component={Paper} children={children} />;